export const FETCH_EVENTS_PENDING = 'FETCH_EVENTS_PENDING';
export const FETCH_EVENTS_FULFILLED = 'FETCH_EVENTS_FULFILLED';
export const FETCH_EVENTS_FAILED = 'FETCH_EVENTS_FAILED';
